/* Garantia Vitalícia Coparticipativa + Cashback — Splin
 * Wizard multi-etapas + integração com a edge function warranty-activate.
 * Sem dependências externas. Sem tokens Liquid — tudo em JS puro.
 */
(function () {
  "use strict";

  // ── Config ────────────────────────────────────────────────────────────────
  var SUPABASE_URL = "https://iqafgixpbdxfrzuckyfd.supabase.co/functions/v1/warranty-activate";
  var SUPABASE_ANON_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlxYWZnaXhwYmR4ZnJ6dWNreWZkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwMTQyODUsImV4cCI6MjA2ODU5MDI4NX0.s_ukLpT_F270fZ2q9gi2QLd2lKbVkRHIBSK1Nxdtlek";

  // Links de avaliação por canal — fáceis de editar aqui.
  var REVIEW_LINKS = {
    mercado_livre: "https://www.mercadolivre.com.br/my_purchases",
    amazon: "https://www.amazon.com.br/gp/css/order-history",
    site: "https://splin.com.br/",
    tiny: "https://splin.com.br/",
    outro: "https://splin.com.br/"
  };
  var WHATSAPP_SAC_URL = "https://wa.me/553132241212";

  // Dicas de onde achar o número do pedido, por canal.
  var ORDER_HINTS = {
    mercado_livre: "Encontre em 'Minhas compras' no app ou site do Mercado Livre — é o número que começa com # (ex: #2000012345678).",
    amazon: "Encontre em 'Meus pedidos' na Amazon — formato 111-1234567-1234567.",
    site: "Encontre no e-mail de confirmação do pedido ou na área 'Meus pedidos' do site Splin.",
    tiny: "Encontre no e-mail de confirmação da compra.",
    outro: "Informe o número ou código que aparece na sua nota fiscal ou comprovante de compra."
  };

  var MAX_FILE_MB = 10;
  var ALLOWED_FILE_TYPES = ["image/jpeg", "image/png", "image/webp", "application/pdf"];

  // ── State ─────────────────────────────────────────────────────────────────
  var state = {
    step: 1,
    totalSteps: 5,
    usage_profile: "",
    rating: 0,
    receiptPath: null,
    lastActivateResponse: null,
    channel: "",
    email: ""
  };

  // ── Helpers ───────────────────────────────────────────────────────────────
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function getOriginParam() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("origem") || params.get("origin") || "";
    } catch (e) {
      return "";
    }
  }

  function showAlert(msg) {
    var el = $("#gwAlert");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("is-visible");
  }

  function hideAlert() {
    var el = $("#gwAlert");
    if (!el) return;
    el.classList.remove("is-visible");
    el.textContent = "";
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.classList.add("is-loading");
      btn.disabled = true;
    } else {
      btn.classList.remove("is-loading");
      btn.disabled = false;
    }
  }

  function formatCurrency(value) {
    var num = Number(value);
    if (isNaN(num)) return "—";
    return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  function formatDate(value) {
    if (!value) return "—";
    var d = new Date(value);
    if (isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("pt-BR");
  }

  // ── Wizard navigation ────────────────────────────────────────────────────
  function updateProgress() {
    $all(".gw__progress-step").forEach(function (el) {
      var stepNum = parseInt(el.getAttribute("data-step"), 10);
      el.classList.toggle("is-active", stepNum === state.step);
      el.classList.toggle("is-done", stepNum < state.step);
    });
    var progressbar = $("#gwProgressbar");
    if (progressbar) progressbar.setAttribute("aria-valuenow", String(state.step));
    var stepNumEl = $("#gwStepNum");
    if (stepNumEl) stepNumEl.textContent = String(state.step);
  }

  function goToStep(n) {
    state.step = n;
    $all(".gw__step").forEach(function (el) {
      var stepNum = parseInt(el.getAttribute("data-step"), 10);
      var active = stepNum === n;
      el.classList.toggle("is-active", active);
      el.setAttribute("aria-hidden", active ? "false" : "true");
    });
    updateProgress();

    var backBtn = $("#gwBack");
    var nextBtn = $("#gwNext");
    if (backBtn) backBtn.style.visibility = n === 1 ? "hidden" : "visible";
    if (nextBtn) {
      nextBtn.querySelector(".gw__btn-label").textContent =
        n === state.totalSteps ? "Ativar garantia e resgatar cashback" : "Continuar";
    }

    var titleEl = $('.gw__step[data-step="' + n + '"] .gw__step-title');
    if (titleEl) titleEl.setAttribute("tabindex", "-1");
    if (titleEl) titleEl.focus({ preventScroll: false });
  }

  function clearFieldError(inputEl, errorEl) {
    if (inputEl) inputEl.classList.remove("is-error");
    if (errorEl) errorEl.classList.remove("is-visible");
  }

  function setFieldError(inputEl, errorEl) {
    if (inputEl) inputEl.classList.add("is-error");
    if (errorEl) errorEl.classList.add("is-visible");
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function isValidPhone(v) {
    var digits = v.replace(/\D/g, "");
    return digits.length >= 10 && digits.length <= 13;
  }

  function validateStep(n) {
    var valid = true;

    if (n === 1) {
      var name = $("#gwName");
      var email = $("#gwEmail");
      var phone = $("#gwPhone");

      if (!name.value.trim() || name.value.trim().split(/\s+/).length < 2) {
        setFieldError(name, $("#gwNameError"));
        valid = false;
      } else clearFieldError(name, $("#gwNameError"));

      if (!isValidEmail(email.value.trim())) {
        setFieldError(email, $("#gwEmailError"));
        valid = false;
      } else clearFieldError(email, $("#gwEmailError"));

      if (!isValidPhone(phone.value.trim())) {
        setFieldError(phone, $("#gwPhoneError"));
        valid = false;
      } else clearFieldError(phone, $("#gwPhoneError"));
    }

    if (n === 2) {
      var channel = $("#gwChannel");
      var orderRef = $("#gwOrderRef");
      if (!channel.value) {
        channel.classList.add("is-error");
        valid = false;
      } else channel.classList.remove("is-error");

      if (!orderRef.value.trim()) {
        orderRef.classList.add("is-error");
        valid = false;
      } else orderRef.classList.remove("is-error");
    }

    if (n === 3) {
      if (!state.usage_profile) {
        $("#gwUsageError").classList.add("is-visible");
        valid = false;
      } else {
        $("#gwUsageError").classList.remove("is-visible");
      }
    }

    // Step 4 is optional — always valid.

    if (n === 5) {
      var consentTerms = $("#gwConsentTerms");
      if (!consentTerms.checked) {
        $("#gwTermsError").classList.add("is-visible");
        valid = false;
      } else {
        $("#gwTermsError").classList.remove("is-visible");
      }
    }

    return valid;
  }

  // ── Step 2: channel-specific hint ───────────────────────────────────────
  function onChannelChange() {
    var channel = $("#gwChannel").value;
    state.channel = channel;
    var hintEl = $("#gwOrderHint");
    var outroNote = $("#gwOutroNote");
    if (hintEl) {
      hintEl.textContent = ORDER_HINTS[channel] || "Informe o número do seu pedido.";
    }
    if (outroNote) {
      outroNote.classList.toggle("is-visible", channel === "outro");
    }
  }

  // ── Step 3: profile cards ───────────────────────────────────────────────
  function onChoiceClick(e) {
    var btn = e.currentTarget;
    var value = btn.getAttribute("data-value");
    state.usage_profile = value;
    $("#gwUsageProfile").value = value;
    $all(".gw__choice").forEach(function (c) {
      var selected = c === btn;
      c.classList.toggle("is-selected", selected);
      c.setAttribute("aria-checked", selected ? "true" : "false");
    });
    $("#gwUsageError").classList.remove("is-visible");
  }

  // ── Step 4: stars ────────────────────────────────────────────────────────
  var RATING_LABELS = {
    1: "Muito ruim",
    2: "Ruim",
    3: "Ok",
    4: "Bom",
    5: "Excelente!"
  };

  function paintStars(value) {
    $all(".gw__star").forEach(function (star) {
      var starValue = parseInt(star.getAttribute("data-value"), 10);
      var active = starValue <= value;
      star.classList.toggle("is-active", active);
      star.setAttribute("aria-checked", starValue === value ? "true" : "false");
    });
    $("#gwRatingLabel").textContent = value ? RATING_LABELS[value] : "";
  }

  function onStarClick(e) {
    var value = parseInt(e.currentTarget.getAttribute("data-value"), 10);
    state.rating = value;
    $("#gwRating").value = String(value);
    paintStars(value);
  }

  function onSkipRating() {
    state.rating = 0;
    $("#gwRating").value = "";
    paintStars(0);
    goToStep(5);
  }

  // ── API calls ────────────────────────────────────────────────────────────
  function apiCall(body) {
    return fetch(SUPABASE_URL, {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + SUPABASE_ANON_KEY,
        "apikey": SUPABASE_ANON_KEY,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    });
  }

  function buildActivatePayload(extra) {
    var payload = {
      name: $("#gwName").value.trim(),
      email: $("#gwEmail").value.trim(),
      phone: $("#gwPhone").value.trim(),
      cpf: $("#gwCpf").value.trim(),
      channel: $("#gwChannel").value,
      order_ref: $("#gwOrderRef").value.trim(),
      usage_profile: state.usage_profile,
      rating: state.rating || undefined,
      consent_terms: $("#gwConsentTerms").checked,
      consent_marketing: $("#gwConsentMarketing").checked,
      origin_param: getOriginParam()
    };
    if (extra) {
      for (var k in extra) payload[k] = extra[k];
    }
    return payload;
  }

  function submitActivation() {
    hideAlert();
    var nextBtn = $("#gwNext");
    setLoading(nextBtn, true);

    var payload = buildActivatePayload(state.receiptPath ? { receipt_path: state.receiptPath } : null);
    state.email = payload.email;

    apiCall({ action: "activate", payload: payload })
      .then(function (result) {
        setLoading(nextBtn, false);
        handleActivateResponse(result);
      })
      .catch(function () {
        setLoading(nextBtn, false);
        showAlert("Não foi possível concluir sua ativação agora. Verifique sua conexão e tente novamente.");
      });
  }

  function handleActivateResponse(result) {
    var status = result.status;
    var data = result.data || {};
    state.lastActivateResponse = data;

    if (status === 409) {
      showResult("gwResultDuplicate");
      return;
    }

    if (status === 400 || status === 403) {
      showAlert(data.error || "Não foi possível processar sua ativação. Verifique os dados informados.");
      return;
    }

    if (!result.ok) {
      showAlert("Ocorreu um erro inesperado. Tente novamente em instantes.");
      return;
    }

    // 200 responses
    if (data.status === "pending_review") {
      showResult("gwResultReview");
      return;
    }

    if (data.warranty_active === false && data.status === "expired_window") {
      renderExpiredCoupon(data);
      showResult("gwResultExpired");
      renderFollowup("gwFollowupExpired", data.followup);
      return;
    }

    if (data.coupon && data.coupon_status === "issued") {
      renderCoupon(data);
      showResult("gwResultCoupon");
      renderFollowup("gwFollowupCoupon", data.followup);
      return;
    }

    // active/pending coupon or no coupon info yet
    showResult("gwResultPending");
    renderFollowup("gwFollowupPending", data.followup);
  }

  function renderCoupon(data) {
    var coupon = data.coupon || {};
    $("#gwCouponCode").textContent = coupon.code || "—";
    $("#gwCouponValue").textContent = coupon.value != null ? formatCurrency(coupon.value) : "—";
    $("#gwCouponMin").textContent = coupon.min_purchase != null ? formatCurrency(coupon.min_purchase) : "—";
    $("#gwCouponExpiry").textContent = formatDate(coupon.expires_at);
    $("#gwCouponEmail").textContent = state.email;
  }

  function renderExpiredCoupon(data) {
    var slot = $("#gwExpiredCouponSlot");
    slot.innerHTML = "";
    if (data.coupon && data.coupon_status === "issued") {
      var wrap = document.createElement("div");
      wrap.className = "gw__coupon";
      wrap.innerHTML =
        '<p class="gw__coupon-label">Seu cupom de cashback</p>' +
        '<div class="gw__coupon-code"><span id="gwExpiredCouponCode"></span>' +
        '<button type="button" class="gw__coupon-copy" id="gwExpiredCopyCoupon">Copiar</button></div>' +
        '<div class="gw__coupon-meta">' +
        '<span><strong id="gwExpiredCouponValue"></strong>desconto</span>' +
        '<span><strong id="gwExpiredCouponMin"></strong>compra mínima</span>' +
        '<span><strong id="gwExpiredCouponExpiry"></strong>validade</span>' +
        "</div>" +
        '<p class="gw__coupon-email-note">Use o e-mail <strong>' + state.email + '</strong> no checkout para aplicar o cupom.</p>';
      slot.appendChild(wrap);
      $("#gwExpiredCouponCode").textContent = data.coupon.code || "—";
      $("#gwExpiredCouponValue").textContent = data.coupon.value != null ? formatCurrency(data.coupon.value) : "—";
      $("#gwExpiredCouponMin").textContent = data.coupon.min_purchase != null ? formatCurrency(data.coupon.min_purchase) : "—";
      $("#gwExpiredCouponExpiry").textContent = formatDate(data.coupon.expires_at);
      $("#gwExpiredCopyCoupon").addEventListener("click", function () {
        copyToClipboard(data.coupon.code, $("#gwExpiredCopyCoupon"));
      });
    } else {
      var note = document.createElement("p");
      note.className = "gw__result-desc";
      note.textContent = "Seu cashback está sendo avaliado e, se aprovado, chega por e-mail em até 1 dia útil.";
      slot.appendChild(note);
    }
  }

  function renderFollowup(containerId, followup) {
    var el = $("#" + containerId);
    if (!el) return;
    el.innerHTML = "";

    if (followup === "review") {
      var channel = $("#gwChannel").value;
      var link = REVIEW_LINKS[channel] || REVIEW_LINKS.site;
      el.innerHTML =
        '<p class="gw__followup-title">Que bom que gostou! Avalie sua compra</p>' +
        '<p class="gw__followup-desc">Sua avaliação ajuda outros clientes a conhecerem os produtos Splin.</p>' +
        '<a class="gw__btn gw__btn--primary gw__btn--full" style="display:block;text-align:center;text-decoration:none;" href="' +
        link + '" target="_blank" rel="noopener">Avaliar minha compra</a>';
      return;
    }

    if (followup === "sac") {
      el.innerHTML =
        '<p class="gw__followup-title">Sentimos muito!</p>' +
        '<p class="gw__followup-desc">Nosso time vai falar com você para resolver o quanto antes.</p>' +
        '<a class="gw__btn gw__btn--wa gw__btn--full" style="display:block;text-align:center;text-decoration:none;" href="' +
        WHATSAPP_SAC_URL + '" target="_blank" rel="noopener">Falar no WhatsApp</a>';
      return;
    }
    // followup null → nothing rendered
  }

  function copyToClipboard(text, btn) {
    if (!text) return;
    var done = function () {
      var original = btn.textContent;
      btn.textContent = "Copiado!";
      setTimeout(function () { btn.textContent = original; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function () { fallbackCopy(text, done); });
    } else {
      fallbackCopy(text, done);
    }
  }

  function fallbackCopy(text, done) {
    var ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand("copy"); } catch (e) {}
    document.body.removeChild(ta);
    done();
  }

  function showResult(resultId) {
    $all(".gw__step").forEach(function (el) { el.classList.remove("is-active"); });
    $("#gwActions").style.display = "none";
    $("#gwProgressbar").style.display = "none";
    $(".gw__progress-label").style.display = "none";
    $all(".gw__result").forEach(function (el) { el.classList.remove("is-active"); });
    var target = $("#" + resultId);
    if (target) target.classList.add("is-active");
  }

  // ── Receipt upload (pending_review flow) ────────────────────────────────
  function onReceiptFileChange(e) {
    var file = e.target.files && e.target.files[0];
    var filenameEl = $("#gwReceiptFilename");
    if (!file) {
      filenameEl.textContent = "";
      return;
    }
    if (ALLOWED_FILE_TYPES.indexOf(file.type) === -1) {
      filenameEl.textContent = "Formato não suportado. Envie JPEG, PNG, WEBP ou PDF.";
      e.target.value = "";
      return;
    }
    if (file.size > MAX_FILE_MB * 1024 * 1024) {
      filenameEl.textContent = "Arquivo muito grande. Tamanho máximo: 10MB.";
      e.target.value = "";
      return;
    }
    filenameEl.textContent = file.name;
  }

  function onSendReceipt() {
    var fileInput = $("#gwReceiptFile");
    var file = fileInput.files && fileInput.files[0];
    var sendBtn = $("#gwSendReceipt");

    if (!file) {
      $("#gwReceiptFilename").textContent = "Selecione um arquivo antes de enviar.";
      return;
    }

    setLoading(sendBtn, true);
    hideAlert();

    apiCall({ action: "upload_url", filename: file.name })
      .then(function (result) {
        if (!result.ok || !result.data || !result.data.signedUrl) {
          throw new Error("upload_url failed");
        }
        var signedUrl = result.data.signedUrl;
        var path = result.data.path;

        return fetch(signedUrl, {
          method: "PUT",
          headers: { "Content-Type": file.type },
          body: file
        }).then(function (putRes) {
          if (!putRes.ok) throw new Error("upload PUT failed");
          state.receiptPath = path;

          var payload = buildActivatePayload({ receipt_path: path });
          state.email = payload.email;
          return apiCall({ action: "activate", payload: payload });
        });
      })
      .then(function (activateResult) {
        setLoading(sendBtn, false);
        if (activateResult.status === 409) {
          showResult("gwResultDuplicate");
          return;
        }
        if (activateResult.data && activateResult.data.status === "pending_review") {
          // Still pending after receipt — show "em análise" message.
          $("#gwUploadBlock").style.display = "none";
          $("#gwSendReceipt").style.display = "none";
          $("#gwReviewSubmitted").style.display = "block";
          return;
        }
        handleActivateResponse(activateResult);
      })
      .catch(function () {
        setLoading(sendBtn, false);
        showAlert("Não foi possível enviar sua nota fiscal agora. Tente novamente.");
      });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    var form = $("#gwForm");
    if (!form) return;

    $("#gwChannel").addEventListener("change", onChannelChange);
    $all(".gw__choice").forEach(function (btn) {
      btn.addEventListener("click", onChoiceClick);
    });
    $all(".gw__star").forEach(function (btn) {
      btn.addEventListener("click", onStarClick);
    });
    $("#gwSkipRating").addEventListener("click", onSkipRating);

    $("#gwNext").addEventListener("click", function () {
      hideAlert();
      if (!validateStep(state.step)) return;

      if (state.step < state.totalSteps) {
        goToStep(state.step + 1);
      } else {
        submitActivation();
      }
    });

    $("#gwBack").addEventListener("click", function () {
      if (state.step > 1) goToStep(state.step - 1);
    });

    $("#gwCopyCoupon").addEventListener("click", function () {
      var code = state.lastActivateResponse && state.lastActivateResponse.coupon
        ? state.lastActivateResponse.coupon.code
        : $("#gwCouponCode").textContent;
      copyToClipboard(code, $("#gwCopyCoupon"));
    });

    $("#gwReceiptFile").addEventListener("change", onReceiptFileChange);
    $("#gwSendReceipt").addEventListener("click", onSendReceipt);

    form.addEventListener("submit", function (e) { e.preventDefault(); });

    goToStep(1);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
